import React,{useEffect,useState} from 'react';
import { Container, Card } from 'react-bootstrap';
import { db } from '../FireBase';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
const TermsAndConditions = () => {

    const [contactInfo, setContactInfo] = useState({});
    useEffect(() => {
        fetchContactInfo();
      }, []);
    
      const fetchContactInfo = async () => {
        const docRef = doc(db, 'settings', 'contact');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContactInfo(docSnap.data());
        }
      };
  return (
    <Container className="p-2" style={{ marginBottom: '40px' }}>
      <Card className="shadow rounded-4 p-4 border-0">
        <Card.Body>
          <h2 className="mb-4 text-center">Terms & Conditions</h2>

          {/* <section className="mb-4">
            <h5>Effective Date</h5>
            <p>[Insert Date]</p>
          </section> */}

          <section className="mb-4">
            <p style={{ textAlign: 'justify' }}>
              These Terms govern your use of the Kabili Holidays website and services.
            </p>
          </section>

          <section className="mb-4">
            <h5>1. Booking Policy</h5>
            <ul>
              <li>All bookings are subject to availability.</li>
              <li>Accurate personal details must be provided for booking confirmation.</li>
              <li>Confirmation will be sent via email upon successful booking.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>2. Payment</h5>
            <ul>
              <li>Full or partial payment is required at the time of booking.</li>
              <li>All payments are processed through secure, encrypted payment gateways.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>3. User Responsibilities</h5>
            <ul>
              <li>Valid government-issued ID proof must be presented upon check-in.</li>
              <li>Guests must follow all local laws and resort property rules.</li>
              <li>Smoking, drinking, and pets are strictly not allowed on the premises.</li>
              <li>Unmarried couples and guests under 18 years of age are not permitted to book or stay.</li>
              <li>Guests are expected to avoid damage or misconduct during their stay.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>4. Limitation of Liability</h5>
            <p>Kabili Holidays is not liable for:</p>
            <ul>
              <li>Delays or cancellations due to weather or unforeseen events</li>
              <li>Errors due to incorrect information provided by the user</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>5. Modification</h5>
            <p>
              We reserve the right to update these terms without prior notice. Please review periodically.
            </p>
          </section>

          <section className="mb-4">
            <h5>6. Contact Information</h5>
            <p style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
              <strong>Address:</strong><br />{contactInfo.address}
            </p>
            <p style={{ textAlign: 'justify' }}>
              <strong>Mail:</strong> <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a><br />
              <strong>Phone:</strong> <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TermsAndConditions;
